/* unplugin-vue-components disabled */
import {Splitter, SplitterPanel} from 'primevue'
import AgentEditor from './agent-editor.vue'
import AgentsList from './agents-list.vue'
import {MAX_TEST_AGENTS} from './test-agents-defs'
import $settings from 'stores/settings'

const TEST_AGENTS_KEY = 'adm_test_agents'
const TEST_SKILLS_KEY = 'adm_test_skills'

export default {
  components: {AgentEditor, AgentsList, Splitter, SplitterPanel},
  data() {
    return {
      editing_idx: undefined,
      agents: undefined,
      tools: [],
      saving: false,
      saved_at: undefined
    }
  },
  async mounted() {
    this.tools = await $settings.getTestAgentTools()
    this.agents = await $settings.get(TEST_AGENTS_KEY, [])
    await this.$nextTick()
    if (this.agents.length) this.$refs.editor.edit(this.agents[0], 0)
  },
  methods: {
    async createAgent(draft) {
      if (this.agents.length >= MAX_TEST_AGENTS) return
      this.agents.push(draft)
      await this.save()
    },

    async saveAgent(idx, draft) {
      const skills_upd = await this.replaceAgent(idx, draft)
      Object.assign(this.agents[idx], draft)
      this.save(skills_upd)
    },

    async deleteAgent(idx) {
      const skills_upd = await this.replaceAgent(idx, null)
      this.agents.splice(idx, 1)
      this.$refs.editor.onAgentDeleted(idx)
      this.save(skills_upd)
    },

    async replaceAgent(idx, replacement) {
      this.saving = true
      const old_name = this.agents[idx]?.name
      if (!old_name) return

      const skills = await $settings.get(TEST_SKILLS_KEY, [])
      const updated_skills = skills.map(skill => {
        if (!skill.subagents?.includes(old_name)) return skill
        const subagents = skill.subagents
          .map(name => name === old_name ? replacement?.name : name)
          .filter(x => !!x)

        return {...skill, subagents}
      })

      const skills_diff = updated_skills.some(
        (skill, idx) => !$utils.object.same(skill, skills[idx])
      )
      if (!skills_diff) return
      return [{key: TEST_SKILLS_KEY, value: updated_skills}]

    },
    async save(side_settings = []) {
      this.saving = true
      try {
        let agents = this.agents.map(agent => $utils.object.deepCopy(agent))
        agents = agents.length ? agents : null
      
        await $settings.putMany([{key: TEST_AGENTS_KEY, value: agents}, ...side_settings])
        this.saved_at = Date.now()
      }
      catch (err) {
        $utils.toasts.error(err)
      }
      this.saving = false
    }
  }
}
